import { ArrowRightIcon } from "@heroicons/react/24/outline";

export function LandingCta() {
  return (
    <section className="relative overflow-hidden bg-slate-950 py-20 sm:py-24">
      <div
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_60%_80%_at_50%_120%,rgba(14,165,233,0.25),transparent)]"
        aria-hidden
      />
      <div className="relative mx-auto max-w-3xl px-4 text-center sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
          Klar for å samle arbeidet?
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-lg text-slate-400">
          Logg inn med bedriftens konto, eller ta kontakt med administrator for
          tilgang og onboarding.
        </p>
        <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <a
            href="/authentication/login"
            className="inline-flex w-full items-center justify-center gap-2 rounded-xl bg-sky-500 px-8 py-3.5 text-base font-semibold text-white shadow-lg shadow-sky-500/30 transition hover:bg-sky-400 sm:w-auto"
          >
            Gå til innlogging
            <ArrowRightIcon className="h-5 w-5" aria-hidden />
          </a>
          <a
            href="mailto:post@airon.no"
            className="inline-flex w-full items-center justify-center rounded-xl border border-white/15 px-8 py-3.5 text-base font-medium text-slate-300 transition hover:bg-white/5 hover:text-white sm:w-auto"
          >
            Kontakt oss
          </a>
        </div>
      </div>
    </section>
  );
}
